import React, { useMemo, useState } from 'react'
import { Page2019 } from '../organisms'
import { Event } from '../../domain/event'
import {
  LandingGraphic,
  TicketsGraphic,
  GetInvolvedGraphic,
  IsoGrid,
  LandingGraphicMobile,
  FAQsGraphic,
  Arrow,
} from '../graphics'
import { Section, JumpLink, JumpGrid } from '../atoms'
import { darkThemeColor } from '../theme'
import {
  VideoEmbed,
  BoxLinkExternal,
  Carousel,
  Display,
  Content,
  Box,
  Columns,
  Rows,
  ContentSmall,
  LinkExternal,
  EmailLink,
  IconButton,
  LinkInternal,
} from '../../design-system'
import { ContentBar, ContentAccordion, FAQQuestion } from '../molecules'
import { ProgrammeSlide } from '../organisms'
import { useCachedResource } from '@invisible-cms/react'

const HomePage = () => {
  const events = useCachedResource(Event.listHomepage, { festival: '2019' })
  const [carouseIndex, setCarouselIndex] = useState(0)

  return (
    <Page2019
      headerBg={<IsoGrid width="100vw" height="100vh" />}
      cover={
        <Rows flex={1}>
          <LandingGraphic
            showFrom="tablet"
            minHeight={0}
            minWidth={0}
            width="100%"
            height="100%"
            transform={{
              tablet: 'translateY(5%)',
            }}
            flex={1}
            flexShrink={1}
            flexBasis={0}
            pointerEvents="none"
            preserveAspectRatio="xMinYMid meet"
          />
          <LandingGraphicMobile
            showUntil="tablet"
            width="100%"
            height="100%"
            minHeight={0}
            minWidth={0}
            flex={1}
            flexBasis={0}
            pointerEvents="none"
            preserveAspectRatio="xMidYMid meet"
          />
          <Columns
            flexShrink={0}
            flip={{ mobile: true, tablet: false }}
            padding={{ mobile: 2, tablet: 3 }}
            justifyContent="space-between"
          >
            <Content>TWT19</Content>
            <Content>21.09.2019 – 24.09.2019</Content>
            <Content>Brighton</Content>
          </Columns>
        </Rows>
      }
    >
      <Section id="about" bg={darkThemeColor.bgAlt}>
        <Content>
          <p>
            The World Transformed is about thinking big. It’s about imagining
            radical change and planning how to make it happen. And it’s about
            doing it together.
          </p>
          <p>
            We’re a 4-day politics, arts and music festival running alongside
            the Labour Party Conference in Brighton, working to build left power
            both inside and outside of Parliament.
          </p>
          <p>
            Since 2016 we’ve been mixing big names with the most inspiring
            grassroots voices from all over the world, tackling topics that
            others overlook. TWT is a space for everyone - from seasoned
            campaigners to people who are brand new to politics.
          </p>
          <p>
            TWT19 is about pushing the boundaries of what political
            participation looks like. Strategy games, treasure hunts, parades,
            reading groups, and theatre workshops will be at the heart of the
            programme. At TWT19 we will be practising a kinder and more generous
            form of discussion and encouraging a politics based on creativity,
            open mindedness and comradeship. We want to transform the way we
            learn together.
          </p>
          <p>
            As much as anything, TWT19 is about setting a radical agenda for the
            Corbyn project and beyond. Four years on, we’ll be taking stock,
            asking: how is it going and where do we go next? At TWT19, we’ll be
            thinking together about the future of our movement and how we can
            make it stronger.
          </p>
          <p>
            What does a world for the many look like? Come to Brighton to help
            build it.
          </p>
        </Content>
      </Section>
      {/* <Section
        wide
        id="programme"
        minHeight="100vh"
        bgGraphic={
          <Box width="100%" height="100%">
            <FAQsGraphic
              position="absolute"
              overflow="visible"
              width="805px"
              height="805px"
              right={0}
              transform="translateY(-40px)"
              preserveAspectRatio="xMidYMin slice"
            />
          </Box>
        }
      >
        <Rows noFlex spacing={2}>
          <Box>
            <Display>Programme</Display>
          </Box>
          <Columns
            spacing={3}
            alignItems="center"
            justifyContent="space-between"
            height="500px"
            flex={1}
          >
            <IconButton
              flexShrink={0}
              onClick={() => setCarouselIndex(carouseIndex - 1)}
            >
              <Arrow direction="left" />
            </IconButton>
            <Carousel height="500px" flex={1} index={carouseIndex}>
              {events.map(e => (
                <ProgrammeSlide key={e.id} event={e} />
              ))}
            </Carousel>
            <IconButton
              flexShrink={0}
              onClick={() => setCarouselIndex(carouseIndex + 1)}
            >
              <Arrow direction="right" />
            </IconButton>
          </Columns>
          <Content>
            <LinkInternal to="/festival/2019/programme">
              <JumpLink>Read the full Programme</JumpLink>
            </LinkInternal>
          </Content>
        </Rows>
      </Section> */}
      <Section
        wide
        id="tickets"
        minHeight="100vh"
        bg="#EF8F05"
        bgGraphic={
          <Box width="100%" height="100%">
            <TicketsGraphic
              position="absolute"
              overflow="visible"
              bottom={-8}
              preserveAspectRatio="xMidYMax slice"
            />
          </Box>
        }
      >
        <Rows spacing={4}>
          <Columns flip={{ mobile: true, desktop: false }} spacing={5}>
            <Box>
              <Display>Tickets</Display>
            </Box>
            <BoxLinkExternal
              href="https://www.tickettailor.com/events/theworldtransformed"
              alignSelf={{ mobile: 'stretch', desktop: 'center' }}
              flex={1}
            >
              <Box height={{ mobile: '30px', desktop: '250px' }} />
              <ContentBar>
                <Content>Unwaged</Content>
                <Content>Free</Content>
              </ContentBar>
              <ContentBar>
                <Content>Concession</Content>
                <Content>£15.00</Content>
              </ContentBar>
              <ContentBar>
                <Content>Standard</Content>
                <Content>£25.00</Content>
              </ContentBar>
              <ContentBar>
                <Content>Solidarity</Content>
                <Content>£50.00</Content>
              </ContentBar>
            </BoxLinkExternal>
          </Columns>
          <Rows justifyContent="center" flexGrow={1}>
            <Content>
              <LinkExternal href="https://www.tickettailor.com/events/theworldtransformed">
                <JumpLink>Buy tickets here!</JumpLink>
              </LinkExternal>
            </Content>
          </Rows>
        </Rows>
      </Section>
      <Box width="100%" bg={darkThemeColor.bgAlt}>
        <VideoEmbed
          height="calc(100vw * 0.5625)"
          maxHeight="100vh"
          video="SJxL5wS3Bag"
        />
      </Box>
      <Section
        wide
        id="get-involved"
        bg="#009340"
        bgGraphic={
          <GetInvolvedGraphic
            top={3}
            right={3}
            parallaxDistance={-0.15}
            preserveAspectRatio="xMaxYMid meet"
          />
        }
      >
        <Rows noFlex spacing={{ mobile: 2, desktop: 5 }}>
          <Box>
            <Display>Get Involved</Display>
          </Box>
          <JumpGrid>
            <>
              <ContentAccordion label="Volunteer" analyticsEvent="volunteer">
                <ContentSmall>
                  <p>
                    The World Transformed is a people-powered event run on a
                    shoestring budget, mostly by a team of dedicated volunteers.
                    We rely on the skills and creativity of our movement to make
                    the festival run smoothly. If you’d like to help make the
                    festival happen, we’d love to hear from you. As a volunteer
                    you will have a free ticket, food (and accommodation and
                    travel if needed).
                  </p>
                  <p>
                    If you’d like to volunteer, fill in{' '}
                    <LinkExternal href="https://theworldtransformed.typeform.com/to/bMRtkq">
                      this form
                    </LinkExternal>
                    .
                  </p>
                  <p>
                    If you’ve any questions about volunteering, contact{' '}
                    <EmailLink address="logistics@theworldtransformed.org" />
                  </p>
                </ContentSmall>
              </ContentAccordion>
              <ContentAccordion
                label="Press Enquiries"
                analyticsEvent="press-enquire"
              >
                <ContentSmall>
                  <p>
                    You can reach our press office at{' '}
                    <EmailLink address="press@theworldtransformed.org" />.
                  </p>
                </ContentSmall>
              </ContentAccordion>
            </>
            <>
              <ContentAccordion
                label="Programme Enquiries"
                analyticsEvent="programme-enquire"
              >
                <ContentSmall>
                  <p>
                    Questions or comments on the TWT programme can be sent to{' '}
                    <EmailLink address="programme@theworldtransformed.org" />.
                  </p>
                  <p>
                    If you want to get involved in our Arts programme, please
                    email <EmailLink address="arts@theworldtransformed.org" />
                  </p>
                  <p>
                    See{' '}
                    <LinkExternal href="https://2018.theworldtransformed.org/programme">
                      here
                    </LinkExternal>{' '}
                    for information on the 2018 programme.
                  </p>
                </ContentSmall>
              </ContentAccordion>
              <ContentAccordion
                label="General Enquiries"
                analyticsEvent="general-enquire"
              >
                <ContentSmall>
                  <p>
                    For all other enquiries, please contact{' '}
                    <EmailLink address="info@theworldtransformed.org" />
                  </p>
                </ContentSmall>
              </ContentAccordion>
            </>
          </JumpGrid>
        </Rows>
      </Section>
      <Section
        wide
        id="faqs"
        bgGraphic={
          <Box width="100%" height="100%">
            <IsoGrid
              height="400px"
              position="absolute"
              width="100%"
              objectFit="none"
            />
            <FAQsGraphic
              position="absolute"
              overflow="visible"
              width="805px"
              height="805px"
              transform="translateY(-40px)"
              preserveAspectRatio="xMidYMin slice"
            />
          </Box>
        }
      >
        <Rows noFlex spacing={2}>
          <Box>
            <Display>FAQs</Display>
          </Box>
          <Rows noFlex padding={2}>
            <FAQQuestion
              analyticsEvent="faq-where"
              q="Where exactly is the festival taking place?"
            >
              <p>
                The festival is taking place in Brighton across eight main
                venues:
              </p>
              <ul>
                <li>TWT Marquee, Old Steine Gardens (South side), BN1 1EL</li>
                <li>68 Middle Street, BN1 1AL</li>
                <li>
                  Brighthelm Centre, North Road (corner with Queen’s Road), BN1
                  1YD
                </li>
                <li>
                  Brighton Table Tennis Club, The Fitzherbert’s Centre, 36 Upper
                  Bedford St, BN2 1JP
                </li>
                <li>Friends Meeting House, Ship Street, BN1 1AF</li>
                <li>Komedia, 44-47 Gardner Street, BN1 1UN</li>
                <li>The Old Market, 11A Upper Market St, BN3 1AS</li>
                <li>Unitarian Church, New Road, BN1 1UF</li>
                <li>Concorde 2, 286A Madeira Dr, BN2 1EN</li>
                <li>Green Door Stores, 2, 3, 4 Trafalgar Arches, BN1 4FG</li>
              </ul>
            </FAQQuestion>
            <FAQQuestion
              analyticsEvent="faq-accessibility"
              q="What are the accessibility arrangements for the festival?"
            >
              <p>We can guarantee the following things at TWT:</p>
              <ul>
                <li>
                  Wheelchair accessible venues and arrangements for those with
                  mobility requirements
                </li>
                <li>
                  Child-friendly venues throughout the festival and a crèche for
                  children over two on Saturday and Sunday
                </li>
                <li>Some affordable travel, accommodation and food options</li>
                <p>
                  If you would like to see a more comprehensive accessibility
                  plan, if you would like to find out more about a certain
                  arrangement, or if you have any particular accessibility or
                  dietary requirements that you want us to know about, please
                  get in touch by emailing{' '}
                  <EmailLink address="logistics@theworldtransformed.org" />.
                </p>
              </ul>
            </FAQQuestion>
            <FAQQuestion q="Can I come to TWT if I’m a Labour Party Conference attendee?">
              Absolutely! The festival is fully open to Conference delegates and
              attendees, and with sessions running every day between 9am and
              9:30pm, there is plenty of festival content for conference-goers
              to participate in.
            </FAQQuestion>
            <FAQQuestion q="What are my transport options?">
              <ul>
                <li>
                  If you’re on Facebook, we have set up a carpool group{' '}
                  <LinkExternal href="https://www.facebook.com/groups/twt2019carpool">
                    here
                  </LinkExternal>{' '}
                  where people can link up with drivers who are going from the
                  same area as them.
                </li>
                <li>
                  Depending where you are travelling from, it may be cheaper to
                  travel by{' '}
                  <LinkExternal href="https://www.thetrainline.com/">
                    train
                  </LinkExternal>{' '}
                  or by coach - we would recommend checking out
                  <LinkExternal href="https://www.nationalexpress.com/en">
                    National Express
                  </LinkExternal>{' '}
                  and{' '}
                  <LinkExternal href="https://uk.megabus.com/">
                    Megabus
                  </LinkExternal>{' '}
                  if you are coming from further away than the South East of
                  England! And remember that since the beginning of this year
                  26-30 Railcards are a thing, so if you’re lucky enough, you
                  may be eligible for 1/3 off in train tickets!
                </li>
              </ul>
            </FAQQuestion>
            <FAQQuestion
              analyticsEvent="faq-accommodation"
              q="What are my accommodation options?"
            >
              <p>
                Brighton will be buzzing with activity during The World
                Transformed. Here are a few options for accommodation during
                those busy days:
              </p>
              <ul>
                <li>
                  We have secured a limited amount of basic communal
                  accommodation for festival goers on a budget - you can find
                  out more info and{' '}
                  <LinkExternal href="http://buytickets.at/theworldtransformed/292682">
                    buy tickets online
                  </LinkExternal>
                  . You will be required to bring your own mat and sleeping bag!
                </li>
                <li>
                  We have set up a TWT Brighton group in couchsurfing.org, for
                  local activists and visitors to pair up for a couch or a spare
                  bed.{' '}
                  <LinkExternal href="https://www.couchsurfing.com/groups/the-world-transformed-2019-twt-brighton">
                    You can join the group here
                  </LinkExternal>
                  . We also recommend you to check the{' '}
                  <LinkExternal href="https://drive.google.com/file/d/1hZTk7MvFYzSxf6zUn8Rk7uC-0h7lM5Q3/view?usp=sharing">
                    TWT guide to a good couchsurfing experience
                  </LinkExternal>{' '}
                  (a compilation of good tips that it’s worth having a look!)
                </li>
                <li>
                  There are a number of youth hostels that offer affordable
                  accommodation in Brighton - you can check in sites such as
                  Hostelworld.com
                </li>
                <li>
                  Brighton has a number of campsites that have good facilities
                  and are at easy reach from central Brighton (most of them
                  easily accessible by car). One that it’s particularly easy to
                  get to is the{' '}
                  <LinkExternal href="https://www.campsites.co.uk/search/campsites-in-sussex/brighton/brighton-caravan-club-site">
                    Brighton Caravan Club Site
                  </LinkExternal>
                  , situated less than 30 minutes away by public transport from
                  our main venue in The Old Steine Gardens, or 45 minutes if you
                  chose to take a morning/evening stroll.
                </li>
                <li>
                  For those who don’t mind commuting into Brighton, here’s a
                  list of nearby towns where you may be able to find affordable
                  accommodation: Shoreham-by-Sea, Saltdean/Rottingdean, Lewes
                  (good train connection), Burgess Hill, Hassocks, Worthing
                  (good train connection), and Falmer (good train connection).
                </li>
              </ul>
            </FAQQuestion>
            <FAQQuestion
              analyticsEvent="faq-which-ticket"
              q="Which ticket option should I go for?"
            >
              We do not police which tickets people decide to buy, we just ask
              that people buy whichever ticket they feel they are able to
              afford. We have a tiered ticketing system in this way so that
              no-one is financially shut out of the festival. For example, every
              £50 solidarity ticket we sell enables us to provide one free
              ticket for those who are unable to afford paid options. So please
              help us keep the festival accessible to all by choosing the ticket
              option that you are able to afford!
            </FAQQuestion>
            <FAQQuestion
              analyticsEvent="faq-volunteering-ticket"
              q="If I am volunteering, do I need to buy a ticket?"
            >
              No - if you’ve been confirmed as a TWT volunteer then you do not
              need a festival ticket.
            </FAQQuestion>
          </Rows>
        </Rows>
      </Section>
    </Page2019>
  )
}

export default HomePage
